export const apps = {
    read(id) {
        return $.getJSON(AdminRoutes.adminAppPath(id));
    },

    destroy(id) {
        return $.ajax({
            method:   'DELETE',
            dataType: 'json',
            url:      AdminRoutes.destroyAdminAppsPath(id),
        });
    },

    destroyMultiple(ids) {
        return $.ajax({
            method:      'POST',
            dataType:    'json',
            contentType: "application/json",
            url:         AdminRoutes.destroyMultipleAdminAppsPath(),
            data:        JSON.stringify({ ids })
        });

    },

    directUploadAppCallback(appType, fileName, uuid, appId = null) {
        let url;
        if (appId) {
            url = AdminRoutes.updateAppCallbackAdminAppPath(appId)
        } else {
            url = AdminRoutes.newAppCallbackAdminAppsPath()
        }
        return $.ajax({
            url,
            method:      'POST',
            dataType:    'json',
            contentType: "application/json",
            data:        JSON.stringify({ appType, fileName, uuid })
        });
    },

    readGroupAssignments(appId, options) {
        return $.getJSON(AdminRoutes.adminAppGroupAssignmentsPath(appId), options);
    },

    readGroupsForAssignments(appId, options) {
        return $.getJSON(AdminRoutes.groupsAdminAppGroupAssignmentsPath(appId), options);
    },

    createGroupAssignment(appId, groupIds, deploymentType, installType) {
        return $.post({
            method: 'POST',
            dataType: 'json',
            contentType: "application/json",
            url: AdminRoutes.adminAppGroupAssignmentsPath(appId),
            data: JSON.stringify({ groupIds, deploymentType, installType })
        })
    },

    removeGroupAssignments(appId, groupIds) {
        return $.ajax({
            url: AdminRoutes.adminAppGroupAssignmentsPath(appId),
            method: 'DELETE',
            dataType: 'json',
            contentType: "application/json",
            data: JSON.stringify({ groupIds }),
        });
    }

};
